import React from 'react';
import {Segment, Tab, Grid} from 'semantic-ui-react';
import PageLayout from '../../layouts/inner-page-layout';

import './index.css';

export class ChatedTabPane extends React.Component {
	render() {
		let headerRow = '';
		if (
			this.props.headerText ||
			this.props.subHeaderText ||
			this.props.action
		) {
			headerRow = (
				<Grid.Row>
					<Grid.Column>
						<h2 className="chated-tab-pane">{ this.props.headerText}</h2>
						<h5 className="chated-tab-pane">{ this.props.subHeaderText }</h5>
						<div className="floated-right-component">{this.props.action}</div>
					</Grid.Column>
				</Grid.Row>
			);
		}
		return (
			<Grid centered className="with-padding">
				{ headerRow }
				<Grid.Row>
					<Grid.Column>
						<Segment style={{minHeight: this.props.containerHeight, padding: `${this.props.padding}px`}}>
							{this.props.children}
						</Segment>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

export class ChatedTab extends React.Component {
	render() {
		const {panes, ...rest} = this.props;
		const formattedPanes = [];

		if (Object.keys(panes).length) {
			panes.forEach((elem) => {
				const pane = {
					menuItem: elem.menuItem,
					render: () => <PageLayout><elem.Content /></PageLayout>
				};

				formattedPanes.push(pane);
			});
		}

		return (
			<Tab menu={{secondary: true, pointing: true}} panes={formattedPanes} className="chated-tab" {...rest} />
		);
	}
}

ChatedTab.Pane = ChatedTabPane;

export default ChatedTab;



// WEBPACK FOOTER //
// ./src/components/tab/index.js